import { render, staticRenderFns } from "./_realTimeTrans.vue?vue&type=template&id=17e44ea7&scoped=true&lang=pug&"
import script from "./_realTimeTrans.vue?vue&type=script&lang=js&"
export * from "./_realTimeTrans.vue?vue&type=script&lang=js&"
import style0 from "./_realTimeTrans.vue?vue&type=style&index=0&id=17e44ea7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e44ea7",
  null
  
)

export default component.exports